export default __webpack_public_path__ + "static/media/con_MOVG04.0a8819e8.jpg";